import { l as loggerUtils } from "./loggerUtils-CebMqdva.js";
let nullableLocalStorage = null;
let nullableSessionStorage = null;
try {
  nullableLocalStorage = window.localStorage;
} catch {
}
try {
  nullableSessionStorage = window.sessionStorage;
} catch {
}
var BrowserStorageType = /* @__PURE__ */ ((BrowserStorageType2) => {
  BrowserStorageType2[BrowserStorageType2["LOCAL_STORAGE"] = 0] = "LOCAL_STORAGE";
  BrowserStorageType2[BrowserStorageType2["SESSION_STORAGE"] = 1] = "SESSION_STORAGE";
  return BrowserStorageType2;
})(BrowserStorageType || {});
function getBrowserStorage(browserStorageType) {
  switch (browserStorageType) {
    case 0:
      return nullableLocalStorage;
    case 1:
      return nullableSessionStorage;
    default:
      throw new Error(`Unknown Browser storage type: ${browserStorageType}`);
  }
}
function isPayloadValid(payloadWrapper, options) {
  const { validTimeInMilliseconds = Number.MAX_VALUE } = options;
  const { updatedAt } = payloadWrapper;
  return !!(updatedAt && Date.now() - updatedAt <= validTimeInMilliseconds);
}
function getValidBrowserStoragePayload(browserStorageType, key, initialValue, options) {
  try {
    const item = getBrowserStorage(browserStorageType)?.getItem(key);
    const payloadWrapper = item && JSON.parse(item);
    if (payloadWrapper && isPayloadValid(payloadWrapper, options)) {
      return payloadWrapper.payload;
    }
    return initialValue;
  } catch {
    return initialValue;
  }
}
function setBrowserStoragePayload(browserStorageType, key, payload) {
  try {
    const payloadWrapper = {
      updatedAt: Date.now(),
      payload
    };
    getBrowserStorage(browserStorageType)?.setItem(key, JSON.stringify(payloadWrapper));
  } catch (error) {
    loggerUtils.logException(error);
  }
}
function clearBrowserStoragePayload(browserStorageType, key) {
  try {
    getBrowserStorage(browserStorageType)?.removeItem(key);
  } catch (error) {
    loggerUtils.logException(error);
  }
}
function clearBrowserStorage(browserStorageType) {
  try {
    getBrowserStorage(browserStorageType)?.clear();
  } catch (error) {
    loggerUtils.logException(error);
  }
}
export {
  BrowserStorageType as B,
  clearBrowserStoragePayload as a,
  clearBrowserStorage as c,
  getValidBrowserStoragePayload as g,
  setBrowserStoragePayload as s
};
//# sourceMappingURL=utils-DueGrJ09.js.map
